import {LANGUAGE} from '@/common/utils/constants';

export const VALIDATE_IN = {
	[LANGUAGE.en.short]: {
		validatedIn: "Language validation:",
		validateProjectTranslationTitle: "Validate project translation"
	},
	[LANGUAGE.de.short]: {
		validatedIn: "Sprachvalidierung:",
		validateProjectTranslationTitle: "Projektübersetzung validieren"
	},
	[LANGUAGE.fr.short]: {
		validatedIn: "Validation linguistique:",
		validateProjectTranslationTitle: "Valider la traduction du projet"
	},
	[LANGUAGE.it.short]: {
		validatedIn: "Convalida della lingua:",
		validateProjectTranslationTitle: "Convalida traduzione del progetto"

	},
	[LANGUAGE.ja.short]: {
		validatedIn: "言語の検証：",
		validateProjectTranslationTitle: " プロジェクトの翻訳を検証します "
	},
	[LANGUAGE.es.short]: {
		validatedIn: "Validación de idioma:",
		validateProjectTranslationTitle: "Validar traducción del proyecto"
	},
}
